import { IQService, IPromise, IDeferred, IRootScopeService } from "angular";
import { IListChartSettings } from "../models/models";

export class ChartSettingsLoader {
  private deferredChartSettings: IDeferred<IListChartSettings>;
  chartSettings: IListChartSettings;
  private isChartSettingsPromiseResolved = false;

  public static $inject = ["$q", "$rootScope"];

  constructor(private $q: IQService, private $rootScope: IRootScopeService) {}

  init(): void {
    // TODO: try to make this event not promise
    this.deferredChartSettings = this.$q.defer<IListChartSettings>();
    this.isChartSettingsPromiseResolved = false;
  }

  promiseChartSettings(): IPromise<IListChartSettings> {
    return this.deferredChartSettings.promise;
  }

  resolveChartSettings(args: IListChartSettings): void {
    this.setChartSettings(args);
    this.deferredChartSettings.resolve(args);
    this.isChartSettingsPromiseResolved = true;
  }

  onManualChartSettingsChange(settings: IListChartSettings): void {
    if (this.isResolved) {
      this.setChartSettings(settings);
      this.$rootScope.$broadcast("chartSettingsChange");
    }
  }

  resetChartSettings(): void {
    this.setChartSettings(null);
  }

  setChartSettings(settings: IListChartSettings): void {
    this.chartSettings = settings;
  }

  get isResolved(): boolean {
    return this.isChartSettingsPromiseResolved;
  }
}
